const getTransformKey = (options) => {
    const { method, transformDeleteParamsIntoBody } = options;
    if (method === 'GET') {
        return 'params';
    }
    if (method === 'DELETE') {
        return transformDeleteParamsIntoBody ? 'data' : 'params';
    }
    return 'data';
};
export const basicParamsTransform = (params, options) => {
    const { urlTemplate } = options;
    if (urlTemplate && options.enableUrlTemplateHeaders) {
        if (!options.headers) {
            options.headers = {};
        }
        options.headers['x-url-template'] = urlTemplate;
    }
    if (params) {
        const key = getTransformKey(options);
        return Object.assign({ [key]: params }, options);
    }
    return options;
};
